'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isCharacterKeyPress = exports.isCharacterKeyPress = function isCharacterKeyPress(ev) {
  if (typeof ev.which == 'undefined') {
    return true;
  } else if (typeof ev.which == 'number' && ev.which > 0) {
    return !ev.ctrlKey && !ev.metaKey && !ev.altKey && ev.which != 8;
  }
  return false;
};


//////////////////
// WEBPACK FOOTER
// ./~/awesome-mask/is-character-keypress.js
// module id = 741
// module chunks = 44